const switches = document.getElementsByClassName("switch");
for (let i = 0; i < switches.length; i++) {
    switches[i].addEventListener("click", handleClickEvent, false);
}

function handleClickEvent(evt) {
    const el = evt.target;

    if (el.getAttribute("aria-checked") === "true") {
        el.setAttribute("aria-checked", "false");
    } else {
        el.setAttribute("aria-checked", "true");
    }
}